import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BackOfficeState } from '@state/back-office/back-office.state';

export const selectBackOfficeState = createFeatureSelector<BackOfficeState>('backOffice');

export const selectRoles = createSelector(selectBackOfficeState, state => state.roles);
export const selectLanguages = createSelector(selectBackOfficeState, state => state.languages);
export const selectCompanies = createSelector(selectBackOfficeState, state => state.companies);
export const selectEmployees = createSelector(selectBackOfficeState, state => state.employees);
export const selectPartners = createSelector(selectBackOfficeState, state => state.partners);
export const selectSelectedPartners = createSelector(selectBackOfficeState, state => state.selectedPartners);

// ############
// USERS
// ############

export const selectUsersLoading = createSelector(selectBackOfficeState, state => state.loadingUsers);
export const selectUsersLoadedPagination = createSelector(selectBackOfficeState, state => state.loadedUsersPagination);
export const selectUsersErrorMessage = createSelector(selectBackOfficeState, state => state.errorUsersMessage);
export const selectUsers = createSelector(selectBackOfficeState, state => state.loadedUsersData);
export const selectUsersGenerating = createSelector(selectBackOfficeState, state => state.generatingUsersReport);

// ############
// TRANSACTIONS
// ############

export const selectTransactionsLoading = createSelector(selectBackOfficeState, state => state.loadingTransactions);
export const selectTransactionsLoadedPagination = createSelector(
  selectBackOfficeState,
  state => state.loadedTransactionsPagination
);
export const selectTransactionsErrorMessage = createSelector(
  selectBackOfficeState,
  state => state.errorTransactionsMessage
);
export const selectTransactions = createSelector(selectBackOfficeState, state => state.loadedTransactionsData);
export const selectTransactionsDownloading = createSelector(
  selectBackOfficeState,
  state => state.downloadingPurchaseDocument
);
export const selectTransactionsGenerating = createSelector(
  selectBackOfficeState,
  state => state.generatingTransactionsReport
);

// ############
// APPLICATIONS
// ############

export const selectApplicationsLoading = createSelector(selectBackOfficeState, state => state.loadingApplications);
export const selectApplicationsLoadedPagination = createSelector(
  selectBackOfficeState,
  state => state.loadedApplicationsPagination
);
export const selectApplicationsErrorMessage = createSelector(
  selectBackOfficeState,
  state => state.errorApplicationsMessage
);
export const selectApplications = createSelector(selectBackOfficeState, state => state.loadedApplicationsData);
export const selectApplicationsGenerating = createSelector(
  selectBackOfficeState,
  state => state.generatingApplicationReport
);

// ############
// SCHEDULED FILES DELETION
// ############

export const selectScheduledFilesDeletionLoading = createSelector(
  selectBackOfficeState,
  state => state.loadingScheduledFilesDeletion
);
export const selectScheduledFilesDeletionLoadedPagination = createSelector(
  selectBackOfficeState,
  state => state.loadedScheduledFilesDeletionPagination
);
export const selectScheduledFilesDeletionErrorMessage = createSelector(
  selectBackOfficeState,
  state => state.errorScheduledFilesDeletionMessage
);
export const selectScheduledFilesDeletion = createSelector(
  selectBackOfficeState,
  state => state.loadedScheduledFilesDeletionData
);

// ############
// MANAGE ASSETS
// ############

export const selectUserProcessManageFiles = createSelector(
  selectBackOfficeState,
  state => state.loadedUserProcessManageFiles
);

export const selectPartnersLoading = createSelector(selectBackOfficeState, state => state.loadingPartners);
